import { Autocomplete, TextField } from "@mui/material";
import { styled } from "@mui/system";
import React from "react";

const AutoCompleteList = ({
  items,
  name,
  label,
  setValue,
  value,
  fullWidth = true,
}) => {
  const GroupHeader = styled("div")(({ theme }) => ({
    position: "sticky",
    top: "-8px",
    padding: "4px 10px",
    color: theme.palette.primary.main,
  }));

  const GroupItems = styled("ul")({
    padding: 0,
  });

  const options = items.map((option) => {
    let firstLetter;
    if (typeof name === "string") {
      firstLetter = option[name][0].toUpperCase();
    } else {
      firstLetter = name(option)[0].toUpperCase();
    }

    return {
      firstLetter: /[0 - 9]/.test(firstLetter) ? "0-9" : firstLetter,
      ...option,
    };
  });

  return (
    <Autocomplete
      fullWidth={fullWidth}
      options={options.sort(
        (a, b) => -b.firstLetter.localeCompare(a.firstLetter)
      )}
      ListboxProps={{
        className: "myCustomList",
      }}
      groupBy={(option) => option.firstLetter}
      getOptionLabel={(option) => {
        if (typeof name === "string") {
          return option[name];
        } else {
          return name(option);
        }
      }}
      sx={{
        "& .MuiOutlinedInput-root": {
          padding: 0.5,
        },
      }}
      renderInput={(params) => <TextField {...params} label={label} />}
      renderGroup={(params) => (
        <li key={params.group}>
          <GroupHeader>{params.group}</GroupHeader>
          <GroupItems>{params.children}</GroupItems>
        </li>
      )}
      value={value}
      onChange={(e, value) => {
        setValue(value);
      }}
      isOptionEqualToValue={(option, value) => {
        return option.id === value.id;
      }}
    />
  );
};

export default AutoCompleteList;
